import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.e1{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.b9{border-radius:1.25rem;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ax{overflow:hidden;}.ssr-plugin'
import '.e2{padding:1rem 1.5rem;}.ssr-plugin'
import '.e3{background:var(--palette-white);}.ssr-plugin'
import '.b5{justify-content:space-between;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.e4{align-self:center;}.ssr-plugin'
import '.c2{padding:1.5rem;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.a{display:grid;}.ssr-plugin'
import '.a3{justify-content:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.e5{gap:0.75rem;}.ssr-plugin'
import '.a2{padding:1rem;}.ssr-plugin'
import '.a1{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.al{border:none;}.ssr-plugin'
import '.e6{border-radius:1rem;}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.e7{transition:background-color 0.2s ease;}.ssr-plugin'
import '.e8{width:1rem;}.ssr-plugin'
import '.e9{height:1rem;}.ssr-plugin'
import '.a6{color:var(--brand-secondary);}.ssr-plugin'
import '.ea{font-size:1.15rem;}.ssr-plugin'
import '.a8{font-weight:400;}.ssr-plugin'
import '.bk{justify-content:flex-end;}.ssr-plugin'
import { styled } from 'inlines'
import { useState } from 'react'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLink } from '@fortawesome/pro-regular-svg-icons'
import { faXTwitter, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { SocialMediaButton } from './SocialMediaButton'

export type SocialShareModalProps = {
  isOpen: boolean
  onClose: () => void
  url?: string
  title?: string
  renderContainer?: HTMLElement
}

export const SocialShareModal = ({
  isOpen,
  onClose,
  url: urlProp,
  title: titleProp,
  renderContainer,
}: SocialShareModalProps) => {
  const translations = useTranslations().app.socialShareModal
  const isMobile = useMediaQuery()
  const [copySuccess, setCopySuccess] = useState(false)

  const url =
    urlProp ?? (typeof window !== 'undefined' ? window.location.href : '')
  const title =
    titleProp ?? (typeof document !== 'undefined' ? document.title : '')

  const handleClose = () => {
    setCopySuccess(false)
    onClose()
  }

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      })
      .catch((err) => {
        console.error('Failed to copy link:', err)
      })
  }

  const handleEmailShare = () => {
    const subject = encodeURIComponent(`Check out: ${title}`)
    const body = encodeURIComponent(
      `I thought you might be interested in this: ${url}`,
    )
    window.open(`mailto:?subject=${subject}&body=${body}`)
  }

  const handleXShare = () => {
    const text = encodeURIComponent(`Check out: ${title}`)
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`,
    )
  }

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    )
  }

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(`Check out: ${title} - ${url}`)
    window.open(`https://wa.me/?text=${text}`)
  }

  if (!isOpen) {
    return null
  }

  const content = (
    <div className="d e e1 b9 t ax"
      data-testid="social-share-modal"
      style={{
        maxWidth: isMobile ? '90vw' : '29.5rem',
      }}
    >
      {/* Header */}
      <div className="d e2 e3 b5 r"
      >
        <Title.H5 style={{ margin: 0 }}>
          {translations.title}
        </Title.H5>
        <CloseButton onClick={handleClose} size="small" />
      </div>

      {/* Content */}
      <div className="d e4 e c2 e3 c"
      >

        {/* Social Media Buttons */}
        <div className="a c" 
          style={{
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',}}
        >
          <SocialMediaButton icon={faEnvelope} label={translations.email} onClick={handleEmailShare} isMobile={isMobile} />
          <SocialMediaButton icon={faXTwitter} label={translations.x} onClick={handleXShare} isMobile={isMobile} />
          <SocialMediaButton icon={faFacebook} label={translations.facebook} onClick={handleFacebookShare} isMobile={isMobile} />
          <SocialMediaButton icon={faWhatsapp} label={translations.whatsapp} onClick={handleWhatsAppShare} isMobile={isMobile} />
        </div>

        {/* Copy Link Button */}
        <styled.button className="d r a3 n e5 a2 a1 al e6 z e7"
          onClick={handleCopyLink}
          style={{
            '&:hover': {
              backgroundColor: 'var(--palette-blue-100)',
            },
          }}
        >
          <div className="e8 e9 d r a3 a6"
          >
            <FontAwesomeIcon icon={faLink} />
          </div>
          <span className="ea a6 a8"
          >
            {copySuccess ? translations.copiedLink : translations.copyLink}
          </span>
        </styled.button>
      </div>

      {/* Footer */}
      <div className="d e2 e3 bk r"
      >
        <Button
          label={translations.close}
          onClick={handleClose}
          variant="primary"
          size="medium"
          style={{
            backgroundColor: 'var(--brand-primary)',
            borderColor: 'var(--brand-primary)',
          }}
        />
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
